<ui-card role="group" [attr.aria-label]="'time-off-v3.policyComponents.timeOffRequestsCard.header' | translate">
    <app-segment-header [title]="'time-off-v3.policyComponents.timeOffRequestsCard.header'">
        <div class="buttons">
            <ui-button *ngIf="editMode" type="link" url="../rules"> {{ 'edit' | translate }} </ui-button>
        </div>
    </app-segment-header>

    <div role="list">
        <div class="field-container" role="listitem" aria-labelledby="waiting-period">
            <span id="waiting-period" class="label">{{
                'time-off-v3.policyComponents.timeOffRequestsCard.waitingPeriod' | translate
            }}</span>
            <div *ngIf="timeOffRequestRule?.waitingPeriod; else noWaitingPeriod">
                {{ timeOffRequestRule?.waitingPeriod | i18nNum }} {{ 'time-off-v3.days' | translate | lowercase }}
            </div>
            <ng-template #noWaitingPeriod>{{
                'time-off-v3.policyComponents.timeOffRequestsCard.waitingPeriodRequestTimeOffOnceEnrolled' | translate
            }}</ng-template>
        </div>

        <div class="field-container" role="listitem" aria-labelledby="maximum-amount">
            <span id="maximum-amount" class="label">{{
                'time-off-v3.policyComponents.timeOffRequestsCard.maximumAmount' | translate
            }}</span>
            <div *ngIf="timeOffRequestRule?.negativeBalanceCap > 0; else noNegativeBalanceAllowed">
                {{ timeOffRequestRule?.negativeBalanceCap | i18nNum }} {{ unitOfTime | translate | lowercase }}
            </div>
            <ng-template #noNegativeBalanceAllowed>{{
                'time-off-v3.policyComponents.timeOffRequestsCard.maximumAmountOfTimeEmployeesCanBook' | translate
            }}</ng-template>
        </div>

        <div class="field-container" role="listitem" aria-labelledby="minimum-length">
            <span id="minimum-length" class="label">{{
                'time-off-v3.policyComponents.timeOffRequestsCard.minimumLength' | translate
            }}</span>
            <div *ngIf="timeOffRequestRule?.minDayAmount > 0; else unlimitedMinLength">
                {{ timeOffRequestRule?.minDayAmount | i18nNum }} {{ unitOfTime | translate | lowercase }}
            </div>
            <ng-template #unlimitedMinLength>{{
                'time-off-v3.policyComponents.timeOffRequestsCard.unlimited' | translate
            }}</ng-template>
        </div>

        <div class="field-container" role="listitem" aria-labelledby="max-total">
            <span id="max-total" class="label">{{
                'time-off-v3.policyComponents.timeOffRequestsCard.maxTotal' | translate
            }}</span>
            <div>
                <ng-container *ngIf="timeOffRequestRule?.maxLength !== null; else unlimitedMaxLength">
                    {{ timeOffRequestRule?.maxLength | i18nNum }} {{ unitOfTime | translate | lowercase }}
                </ng-container>
                <ng-template #unlimitedMaxLength>{{
                    'time-off-v3.policyComponents.timeOffRequestsCard.unlimited' | translate
                }}</ng-template>
            </div>
        </div>
    </div>
</ui-card>
